import { MessageDelayerClass } from '../../core/models/message';
import { Component, OnInit, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'delay',
    templateUrl: './delay.component.html',
    styleUrls: ['./delay.component.scss'],
    standalone: true,
    imports: [NgTemplateOutlet]
})
export class DelayComponent implements OnInit {

  @Input() delay: MessageDelayerClass = new MessageDelayerClass();
  
  constructor() { }

  ngOnInit(): void {
  }
}
